import Typesense from "typesense";
const production = process.env.REACT_APP_MY_PRODUCTION;
// const Typesense = require("typesense");
export const client =
  production == 0
    ? new Typesense.Client({
        nearestNode: {
          host: "yu68x349s2cvf7mhp-1.a1.typesense.net",
          port: "443",
          protocol: "https",
        },
        nodes: [
          {
            host: "yu68x349s2cvf7mhp-1.a1.typesense.net",
            port: "443",
            protocol: "https",
          },
        ],
        apiKey: "eIct4f6cKG4NgixJvzJ44AIp31oxO3Qy",
        connectionTimeoutSeconds: 2,
      })
    : new Typesense.Client({
        nearestNode: {
          host: "x1a8iy9s5tbm4u6wp-1.a1.typesense.net",
          port: "443",
          protocol: "https",
        },
        nodes: [
          {
            host: "x1a8iy9s5tbm4u6wp-1.a1.typesense.net",
            port: "443",
            protocol: "https",
          },
        ],
        apiKey: "PAEBwr1upqSLyukWqd24HCDX4IYYm9y2",
        connectionTimeoutSeconds: 2,
      });

export const QueryTypesense = async (params, collection) => {
  let searchParameters = params;
  const a = await client
    .collections(collection)
    .documents()
    .search(searchParameters);
   return a.hits;
};

export const MultipleQueryTypesense = async (queries, commonParams) => {
  try {
    // const Typesense = require("typesense");
    const a = await client.multiSearch.perform(queries, commonParams);
    let _res = [];
    const results = a?.results || [];
     for (let index = 0; index < results.length; index++) {
      const { hits } = results[index];
      _res = [..._res, ...hits];
    }
    // results.foreach(({ hits }) => (_res = [..._res, ...hits]));
    return _res || [];
  } catch (error) {
    console.log("Typesense error", error);
    return [];
  }
};
